import Message from 'Components/Message';
import React from 'react';
import { Button } from 'reactstrap';


interface EditPermissionPopUPType {
    unlockReport: () => void;
    unlockMode?: 'edit' | 'add' | '';
    setState: (val: boolean) => void;
    isOngoingReport: boolean;
    isEditing: boolean;
}

const EditPermissionPopUP = ({
    unlockReport,
    unlockMode = 'edit',
    setState,
    isOngoingReport,
    isEditing,
}: EditPermissionPopUPType) => {
    let message = '';
    let showConfirmButtons = true;

    if (!isOngoingReport === true) {
        message =
            'There are one or more reports pending submission. Please inform the ship staff to submit all pending reports before attempting to edit any submitted report.';
        showConfirmButtons = false;
    } else if (isEditing) {
        message =
            "Edit access can be granted to only one report at a time. Clicking 'Yes' will revoke access from the other report and grant it to this one. Do you want to continue?";
    } else {
        message = `Are you sure you want to ${unlockMode === 'edit' ? 'edit' : 'insert new after'} this report?`;
    }

    return (
        <div className='pt-2'>
            <Message message={message} type="warning" />
            <div className='d-flex justify-content-end gap-3 m-2 mt-3'>
                {showConfirmButtons ? (
                    <>
                        <Button color="danger" onClick={() => { unlockReport(); setState(false); }}>
                            Yes
                        </Button>
                        <Button color="primary" onClick={() => setState(false)}>
                            No
                        </Button>
                    </>
                ) : (
                    <Button color="primary" onClick={() => setState(false)}>
                        Ok
                    </Button>
                )}
            </div>
        </div>
    );
};

export default EditPermissionPopUP;
